export const FORM_LOCAL_STORAGE_KEY = "@Home/form-data";
